<template>
  <transition name="fade" appear>
    <a :class="{ 'alternate-theme': alternateTheme }" v-if="external || link[0] === '#'" :href="link" >
      <img src="@/assets/images/top-divider.svg" alt="" class="top-divider"/>
      <span>{{ text }}</span>
      <img src="@/assets/images/bottom-divider.svg" alt="" class="bottom-divider"/>
    </a>
    <button :class="{ 'alternate-theme': alternateTheme }" v-else>
      <img src="@/assets/images/top-divider.svg" alt="" class="top-divider"/>
      <span>{{ text }}</span>
      <img src="@/assets/images/bottom-divider.svg" alt="" class="bottom-divider"/>
    </button>
  </transition>
</template>

<script>
export default {
  name: "TimeButton",
  props: {
    text: String,
    link: String,
    alternateTheme: Boolean,
    external: Boolean,
  },
};
</script>

<style lang="scss" scoped>
a,
button {
  font-size: 22px;
  font-weight: 300;
  text-decoration: none;
  color: var(--white);
  border: none;
  text-transform: uppercase;  
  user-select: none;
  display: flex;
  flex-direction: column;
  gap:10px;
  position: relative;
  transition: 0.2s all ease-in-out;
  border: 1px solid var(--accent);
  cursor: pointer;
  span {
    position: relative;
  }
  &:before {
    content: "";
    transition: 0.2s all ease-in-out;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, #4b92db 0%, #4b92db 100%);
    opacity: 0;
    border-radius: 2px;
  }
  &.selected {
    pointer-events: none;
    &:before {
      opacity: 1;
    }
  }
  @media (hover: hover) {
    &:not(.disabled) {
      &:hover {
        background: var(--black);
      }
    }
  }
}
</style>